import React, { useEffect, useRef } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Scrollbars } from "react-custom-scrollbars";
import { useLanguage } from "lang/Translate";

//css
import "./scss/App.scoped.scss";
import "lib/loaders.min.css";

// common components
import ProtectedRoute from "components/common/ProtectedRoute";
import isLoggedIn from "components/auth/isLoggedIn";

//Components
import AirlineCreation from "./other/airlineCreation/AirlineCreation";
import GroupCreation from "./other/groupCreation/GroupCreation";
import VerifyEmail from "./auth/VerifyEmail/VerifyEmail";
import Offline from "./offline/Offline";
import Privacy from "./privacy/privacy";
import Terms from "./terms/Terms";
import Game from "./game/Game";
import Home from "./home/Home";

import { useTranslate } from "lang/Translate";
import useEventListener from "hooks/useEventListener";

let memorisedScroll = 0;
function App() {
	const lang = useLanguage();
	const scrollbarRef = useRef();
	const dispatch = useDispatch();
	const scrollLocked = useRef(false);

	const VERSION_TEXT = useTranslate({ component: "App", Tkey: "VERSION" });
	const BUILD_NUMBER_TEXT = useTranslate({ component: "App", Tkey: "BUILD_NUMBER" });

	const __BUILD_NUMBER__ = process.env.__BUILD_NUMBER__;

	const dispatchScrollEvent = () => document.dispatchEvent(new CustomEvent("onGlobalScroll"));
	const updateGlobalScroll = () => {
		if (!scrollLocked.current) {
			window.scrollTop = scrollbarRef.current.getScrollTop();
			scrollbarRef.current.scrollLeft(0);
			return;
		}

		scrollbarRef.current.scrollTop(memorisedScroll);
		window.scrollTop = memorisedScroll;
	};

	useEffect(() => {
		(async () => {
			const response = await isLoggedIn();
			dispatch({ type: "LOGIN_SET", state: response });
		})();
	}, [dispatch]);

	useEffect(() => {
		setInterval(() => {
			const contentHeight = document.querySelector(".filler")?.clientHeight;
			if (!contentHeight) return;
			if (contentHeight - 17 <= window.innerHeight) {
				scrollbarRef.current.trackVertical.style.visibility = "hidden";
			} else {
				scrollbarRef.current.trackVertical.style.visibility = "visible";
			}
		}, 250);
	}, []);

	useEventListener(document, "restoreGlobalScroll", () => {
		window.scrollTop = scrollbarRef.current.getScrollTop();
	});

	useEventListener(document, "disableGlobalScroll", () => {
		scrollLocked.current = true;
		memorisedScroll = window.scrollTop;
	});

	useEventListener(document, "enableGlobalScroll", () => {
		scrollLocked.current = false;
	});

	let basePath = "";
	if (window.location.pathname.includes("agm")) {
		basePath = "/agm/";
	} else if (window.location.pathname.includes("AirlinesGroupManager")) {
		basePath = "/AirlinesGroupManager/";
	}

	return (
		<div className="App">
			<Scrollbars
				className="scroll_container scroll_container--light scroll_container--track-visible scroll_container--root"
				hideTracksWhenNotNeeded={true}
				renderTrackVertical={props => <div {...props} className="track_vertical" />}
				renderThumbVertical={props => <div {...props} className="thumb_vertical" />}
				renderTrackHorizontal={props => <div {...props} className="track-horizontal" style={{ display: "none" }} />}
				renderThumbHorizontal={props => <div {...props} className="thumb-horizontal" style={{ display: "none" }} />}
				renderView={props => <div {...props} />}
				onScrollFrame={updateGlobalScroll}
				onScroll={dispatchScrollEvent}
				ref={scrollbarRef}
			>
				<BrowserRouter basename={basePath}>
					<Switch>
						<ProtectedRoute path="/createAirline" component={() => <AirlineCreation />} />
						<ProtectedRoute path="/createGroup" component={() => <GroupCreation />} />
						<ProtectedRoute path="/game" component={() => <Game />} />
						<Route path="/terms" render={() => <Terms lang={lang} />} />
						<Route path="/termsPL" render={() => <Terms lang={"PL"} />} />
						<Route path="/privacy" render={() => <Privacy lang={lang} />} />
						<Route path="/privacyPL" render={() => <Privacy lang={"PL"} />} />
						<Route path="/verification" render={() => <VerifyEmail />} />
						<Route path="/" render={() => <Home />} />
					</Switch>
				</BrowserRouter>

				<Offline />
			</Scrollbars>

			<div className="build_number">
				<span>
					{VERSION_TEXT + " "}
					{require("../../package.json").version}
				</span>
				<span>
					{BUILD_NUMBER_TEXT} {__BUILD_NUMBER__}
				</span>
			</div>
		</div>
	);
}

export default App;
